module.exports = __webpack_public_path__ + "static/img/MAITLAND.706ca27.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/MAITLAND.jpg
// module id = /kk4
// module chunks = 0